import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useLocation } from 'react-router-dom';

export default function OrganizationSettingsPage() {
    const { user, logout } = useAuth();
    const [activeTab, setActiveTab] = useState('account');
    const location = useLocation();
    const isSidebarOpen = location?.state?.isSidebarOpen;

    return (
        <div className={`max-w-4xl mx-auto ${isSidebarOpen ? 'md:ml-64' : 'md:ml-0'}`}>
            <h1 className="text-3xl font-extrabold text-gray-900 dark:text-white">Organization Settings</h1>
            <p className="mt-1 text-gray-500 dark:text-gray-400">Manage your organization account settings and preferences.</p>

            <div className="mt-8 bg-white dark:bg-gray-800 shadow-lg rounded-xl overflow-hidden">
                {/* Tab Navigation */}
                <div className="border-b border-gray-200 dark:border-gray-700">
                    <nav className="flex space-x-8 px-6">
                        {['account', 'notifications', 'team', 'security'].map((tab) => (
                            <button
                                key={tab}
                                onClick={() => setActiveTab(tab)}
                                className={`py-4 px-1 border-b-2 font-medium text-sm capitalize ${
                                    activeTab === tab
                                        ? 'border-orange-500 text-orange-600 dark:text-orange-400'
                                        : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
                                }`}
                            >
                                {tab}
                            </button>
                        ))}
                    </nav>
                </div>

                {/* Tab Content */}
                <div className="p-6">
                    {activeTab === 'account' && (
                        <div>
                            <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4">Account Information</h3>
                            <div className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Organization Name</label>
                                    <p className="mt-1 text-gray-900 dark:text-gray-100">{user?.organizationName || 'Not set'}</p>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Email Address</label>
                                    <p className="mt-1 text-gray-900 dark:text-gray-100">{user?.email}</p>
                                </div>
                            </div>
                        </div>
                    )}

                    {activeTab === 'notifications' && (
                        <div>
                            <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4">Notification Preferences</h3>
                            <p className="text-gray-600 dark:text-gray-400">Organization notification settings will be available soon.</p>
                        </div>
                    )}

                    {activeTab === 'team' && (
                        <div>
                            <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4">Team Management</h3>
                            <p className="text-gray-600 dark:text-gray-400">Team management features for organizations will be available in a future update.</p>
                        </div>
                    )}

                    {activeTab === 'security' && (
                        <div>
                            <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4">Security Settings</h3>
                            <div className="space-y-4">
                                <button className="bg-orange-500 text-white px-4 py-2 rounded-md hover:bg-orange-600 transition-colors">
                                    Change Password
                                </button>
                                <button 
                                    onClick={logout}
                                    className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600 transition-colors ml-4"
                                >
                                    Log Out
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}